import React from "react";
import { ptBR } from 'date-fns/locale';
import ReactDatePicker from 'react-datepicker';
import { format, parseISO } from 'date-fns';

const ReactDataPickerComp = ({
    selected,
    onChange,
    className,
    showMonthYearPicker,
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    placeholderText,
    dateFormat,
    wrapperClassName,
    timeCaption,
    style,
    readOnly,
    disabled,
    onBlur,
    setter,
    showYearPicker,
    timeIntervals
}) => {

    const handleRawChange = (e) => {
        if (timeFormat && timeFormat.toUpperCase() === 'HH:MM') {
            const rawValue = e.target.value;

            const lastChar = rawValue.slice(-1);
            if (!/^\d$/.test(lastChar)) {
                return;
            }

            const sanitizedValue = rawValue.replace(/[^0-9]/g, '');

            if (sanitizedValue.length > 4) {
                return;
            }

            let formattedValue = '';
            if (sanitizedValue.length === 0) {
                formattedValue = '';
            } else if (sanitizedValue.length <= 2) {
                formattedValue = sanitizedValue;
            } else {
                formattedValue = `${sanitizedValue.slice(0, 2)}:${sanitizedValue.slice(2)}`;
            }

            e.target.value = formattedValue;

            const timeFormatRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
            if (timeFormatRegex.test(formattedValue)) {
                const [hours, minutes] = formattedValue.split(':').map(Number);

                const now = new Date();
                now.setHours(hours, minutes, 0, 0);
                setter(now);
            }
        }
    };

    function convertLocalTimeToInstant(localTime) {
        const isLocalTimeFormat = /^\d{2}:\d{2}:\d{2}$/.test(localTime);

        if (!localTime || !isLocalTimeFormat) {
            return localTime
        }

        const today = new Date();
        const [hours, minutes, seconds] = localTime.split(':').map(Number);
        today.setHours(hours, minutes, seconds, 0);
        return today;
    }

    const timeFormatRegex = /^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/;
    let selectedDate = selected;
    if (typeof selectedDate === 'string' && selectedDate && !timeFormatRegex.test(selectedDate)) {
        selectedDate = parseISO(selected);
    }

    let showMonthYearPickerValueHelper = showMonthYearPicker
    if (dateFormat === 'MM/YYYY') {
        showMonthYearPickerValueHelper = true
    }

    let showTimeSelectOnlyHelper = showTimeSelectOnly
    if (timeFormat && timeFormat.toUpperCase() === 'HH:MM') {
        showTimeSelectOnlyHelper = true
    }

    if (selectedDate) {
        selectedDate = convertLocalTimeToInstant(selectedDate)
    }

    return (
        <ReactDatePicker
            selected={selectedDate}
            onChange={onChange}
            className={className}
            showMonthYearPicker={showMonthYearPickerValueHelper}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnlyHelper}
            timeFormat={timeFormat}
            placeholderText={placeholderText}
            dateFormat={dateFormat ? dateFormat : 'dd/MM/yyyy'}
            showYearPicker={showYearPicker}
            wrapperClassName={wrapperClassName}
            timeCaption={timeCaption}
            style={{ ...style, width: '150px' }}
            locale={ptBR}
            readOnly={readOnly}
            disabled={disabled}
            onBlur={onBlur}
            onChangeRaw={handleRawChange}
            timeIntervals={timeIntervals}
        />
    );

};

export default ReactDataPickerComp;
